/* Base boutique : code promo du panier, avis, ajout rapide (repris de Braise/Galbe) */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n) => String(n).padStart(2, '0');
  const DAYS = ['zo.', 'ma.', 'di.', 'wo.', 'do.', 'vr.', 'za.'];
  const MONTHS = ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
  const fmtDay = (d) => `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;

  /* Compte à rebours ---------------------------------------------------- */
  class PCountdown extends HTMLElement {
    connectedCallback() {
      this.target = new Date(this.dataset.target).getTime();
      if (Number.isNaN(this.target)) return;
      this.els = {
        d: this.querySelector('[data-days]'),
        h: this.querySelector('[data-hours]'),
        m: this.querySelector('[data-minutes]'),
        s: this.querySelector('[data-seconds]'),
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    tick() {
      const diff = this.target - Date.now();
      if (diff <= 0) {
        clearInterval(this.timer);
        this.innerHTML = `<p class="p-countdown__expired">${this.dataset.expired || ''}</p>`;
        return;
      }
      const s = Math.floor(diff / 1000);
      this.els.d.textContent = pad(Math.floor(s / 86400));
      this.els.h.textContent = pad(Math.floor((s % 86400) / 3600));
      this.els.m.textContent = pad(Math.floor((s % 3600) / 60));
      this.els.s.textContent = pad(s % 60);
    }
  }
  if (!customElements.get('p-countdown')) customElements.define('p-countdown', PCountdown);

  /* Estimation de livraison --------------------------------------------- */
  const addBusinessDays = (date, n) => {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  };

  class PDelivery extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer = setInterval(() => this.update(), 30000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    update() {
      const min = parseInt(this.dataset.min, 10) || 5;
      const max = parseInt(this.dataset.max, 10) || 10;
      const now = new Date();
      const from = addBusinessDays(now, min);
      const to = addBusinessDays(now, max);
      
      this.querySelector('[data-delivery-eta]').textContent = `tussen ${fmtDay(from)} en ${fmtDay(to)}`;
    }
  }
  if (!customElements.get('p-delivery')) customElements.define('p-delivery', PDelivery);

  /* Avis : filtres, tri, pagination, « lire la suite » ------------------ */
  class PReviews extends HTMLElement {
    connectedCallback() {
      this.perPage = parseInt(this.dataset.perPage, 10) || 6;
      this.shown = this.perPage;
      this.filter = 'all';
      this.grid = this.querySelector('[data-grid]');
      this.items = Array.from(this.grid.children);
      this.moreBtn = this.querySelector('[data-load-more]');
      this.empty = this.querySelector('[data-empty]');

      this.querySelectorAll('.p-chip').forEach((chip) =>
        chip.addEventListener('click', () => {
          this.querySelectorAll('.p-chip').forEach((c) => {
            c.classList.toggle('is-active', c === chip);
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });
          this.filter = chip.dataset.filter;
          this.page = 0;
          this.render();
        })
      );
      this.querySelector('[data-sort]')?.addEventListener('change', (e) => this.sort(e.target.value));
      this.page = 0;
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.pageLabel = this.querySelector('[data-page-label]');
      this.prevBtn?.addEventListener('click', () => this.go(-1));
      this.nextBtn?.addEventListener('click', () => this.go(1));
      let startX = null;
      this.grid.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      this.grid.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) this.go(dx < 0 ? 1 : -1);
        startX = null;
      });
      this.items.forEach((item) => {
        const btn = item.querySelector('[data-helpful-btn]');
        btn?.addEventListener('click', () => {
          const span = btn.querySelector('[data-count]');
          const pressed = btn.getAttribute('aria-pressed') === 'true';
          span.textContent = parseInt(span.textContent, 10) + (pressed ? -1 : 1);
          btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        });
        const more = item.querySelector('[data-more]');
        more?.addEventListener('click', () => {
          const body = item.querySelector('[data-clamp]');
          const open = body.classList.toggle('is-open');
          more.textContent = open ? 'Minder' : 'Lees meer';
        });
      });
      this.sort('recent');
    }
    sort(mode) {
      const key = {
        recent: (el) => parseInt(el.dataset.date, 10),
        best: (el) => parseInt(el.dataset.rating, 10) * 1e9 + parseInt(el.dataset.date, 10),
        helpful: (el) => parseInt(el.dataset.helpful, 10),
      }[mode];
      this.items.sort((a, b) => key(b) - key(a)).forEach((el) => this.grid.appendChild(el));
      this.page = 0;
      this.render();
    }
    matches(el) {
      if (this.filter === 'all') return true;
      if (this.filter === 'photo') return el.dataset.photo === '1';
      if (this.filter.startsWith('motif:')) return el.dataset.motif === this.filter.slice(6);
      return true;
    }
    go(dir) {
      const pages = Math.max(1, Math.ceil(this.items.filter((el) => this.matches(el)).length / this.perPage));
      const next = Math.min(pages - 1, Math.max(0, this.page + dir));
      if (next === this.page) return;
      this.page = next;
      this.render(dir);
      const top = this.getBoundingClientRect().top;
      if (top < 0) this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
    render(dir = 0) {
      const list = this.items.filter((el) => this.matches(el));
      const pages = Math.max(1, Math.ceil(list.length / this.perPage));
      if (this.page > pages - 1) this.page = pages - 1;
      const from = this.page * this.perPage;
      const to = from + this.perPage;
      this.items.forEach((el) => (el.hidden = true));
      list.slice(from, to).forEach((el) => (el.hidden = false));
      if (this.empty) this.empty.hidden = list.length > 0;
      if (this.pageLabel) this.pageLabel.textContent = `${this.page + 1} / ${pages}`;
      if (this.prevBtn) this.prevBtn.disabled = this.page === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.page >= pages - 1;
      this.classList.toggle('is-single-page', pages <= 1);
      if (dir && !reduceMotion) {
        this.grid.classList.remove('a-rv-in-next', 'a-rv-in-prev');
        void this.grid.offsetWidth;
        this.grid.classList.add(dir > 0 ? 'a-rv-in-next' : 'a-rv-in-prev');
      }
      requestAnimationFrame(() =>
        this.items.forEach((el) => {
          if (el.hidden) return;
          const body = el.querySelector('[data-clamp]');
          const more = el.querySelector('[data-more]');
          if (!body || !more || body.classList.contains('is-open')) return;
          more.hidden = body.scrollHeight <= body.clientHeight + 4;
        })
      );
    }
  }
  if (!customElements.get('p-reviews')) customElements.define('p-reviews', PReviews);

  /* Boîtes de dialogue ---------------------------------------------------- */
  const openDialog = (dialog) => {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.body.classList.add('p-dialog-open');
  };
  const closeDialog = (dialog) => {
    if (!dialog) return;
    dialog.close();
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-p-open]');
    if (opener) {
      e.preventDefault();
      openDialog(document.getElementById(opener.dataset.pOpen));
      return;
    }
    const closer = e.target.closest('[data-p-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }
    if (e.target.matches('dialog.p-dialog')) {
      const r = e.target.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(e.target);
      return;
    }
    const reviewOpener = e.target.closest('[data-p-review-open]');
    if (reviewOpener) {
      const section = reviewOpener.closest('.p-reviews');
      const review = section.querySelector(`#review-${reviewOpener.dataset.pReviewOpen}`);
      const dialog = section.querySelector('.p-review-dialog');
      if (!review || !dialog) return;
      const clone = review.cloneNode(true);
      clone.removeAttribute('id');
      clone.hidden = false;
      clone.querySelector('[data-clamp]')?.classList.add('is-open');
      clone.querySelectorAll('[data-more], [data-helpful-btn]').forEach((n) => n.remove());
      const img = reviewOpener.querySelector('img') || review.querySelector('.p-review__img img');
      const content = dialog.querySelector('[data-dialog-content]');
      content.innerHTML = '';
      if (img) {
        const big = document.createElement('img');
        big.src = img.dataset.full || img.currentSrc || img.src;
        if (!img.dataset.full) big.srcset = img.srcset;
        big.sizes = '(min-width: 990px) 50vw, 100vw';
        big.alt = img.alt;
        big.className = 'p-review-dialog__img';
        content.appendChild(big);
      }
      clone.querySelectorAll('.p-review__img, .p-review__imgs').forEach((n) => n.remove());
      content.appendChild(clone);
      openDialog(dialog);
    }
  });
  document.addEventListener(
    'close',
    (e) => {
      if (e.target.matches?.('dialog.p-dialog') && !document.querySelector('dialog.p-dialog[open]')) {
        document.body.classList.remove('p-dialog-open');
      }
    },
    true
  );
  // Après l’envoi d’un avis, Shopify recharge la page : on rouvre le formulaire pour afficher la confirmation.
  if (/contact_posted=true/.test(window.location.search) || window.location.hash === '#p-review-form') {
    const form = document.getElementById('p-review-form');
    if (form) openDialog(form.closest('dialog'));
  }

  /* Barre d’achat fixe (fiche produit) ----------------------------------- */
  class PStickyAtc extends HTMLElement {
    connectedCallback() {
      this.mainBtn = document.querySelector('product-info product-form [type="submit"], product-form [name="add"]');
      if (!this.mainBtn) return;
      const json = this.parentElement.querySelector('[data-p-sticky-variants]');
      this.variants = json ? JSON.parse(json.textContent) : {};
      this.btn = this.querySelector('[data-sticky-add]');
      this.label = this.querySelector('[data-sticky-label]');
      this.defaultLabel = this.label.textContent.trim();
      this.btn.addEventListener('click', () => {
        if (this.mainBtn.disabled) {
          this.mainBtn.closest('product-info')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        this.mainBtn.click();
      });

      const footer = document.querySelector('.footer');
      this.mainVisible = true;
      this.footerVisible = false;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.mainBtn) {
            this.mainVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
          } else {
            this.footerVisible = entry.isIntersecting;
          }
        });
        this.toggle(!this.mainVisible && !this.footerVisible);
      });
      io.observe(this.mainBtn);
      if (footer) io.observe(footer);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data?.variant) this.setVariant(data.variant.id);
        });
      }
      const idInput = document.querySelector('product-form input[name="id"]');
      if (idInput) {
        new MutationObserver(() => this.setVariant(idInput.value)).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }
    toggle(show) {
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('p-sticky-on', show);
    }
    setVariant(id) {
      const v = this.variants[id];
      if (!v) return;
      this.querySelector('[data-sticky-variant]').textContent = v.title;
      this.querySelector('[data-sticky-price]').textContent = v.price;
      const img = this.querySelector('[data-sticky-img]');
      if (img && v.image) img.src = v.image;
      this.btn.disabled = !v.available;
      this.label.textContent = v.available ? this.defaultLabel : 'Uitverkocht';
    }
  }
  if (!customElements.get('p-sticky-atc')) customElements.define('p-sticky-atc', PStickyAtc);

  /* Vignettes photo sur les boutons de motif (fiche produit) ------------- */
  const decorateMotifs = () => {
    const json = document.querySelector('[data-p-sticky-variants]');
    if (!json) return;
    const variants = Object.values(JSON.parse(json.textContent));
    document.querySelectorAll('variant-selects fieldset').forEach((fieldset) => {
      const legend = fieldset.querySelector('legend');
      if (!legend || !/motif|couleur/i.test(legend.textContent)) return;
      fieldset.classList.add('p-motif-picker');
      fieldset.querySelectorAll('input[type="radio"] + label').forEach((label) => {
        if (label.querySelector('.p-motif-thumb')) return;
        const value = label.previousElementSibling.value;
        const match = variants.find((v) => v.title.split(' / ').includes(value) && v.image);
        if (!match) return;
        const img = document.createElement('img');
        img.className = 'p-motif-thumb';
        img.src = match.image;
        img.alt = '';
        img.width = 32;
        img.height = 32;
        img.loading = 'lazy';
        label.prepend(img);
      });
    });
  };
  decorateMotifs();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(decorateMotifs, 30));
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(decorateMotifs, 30));
    });
  }

  /* Braises animées (même attribut data-p-rain que la pluie d’Averse) ------------ */
  const rain = (host) => {
    const canvas = document.createElement('canvas');
    canvas.className = 'p-rain-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    host.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    let w = 0;
    let h = 0;
    let sparks = [];
    let running = false;
    let raf;
    let t = 0;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const spawn = (anywhere) => {
      const z = Math.random();
      return {
        x: Math.random() * w,
        y: anywhere ? Math.random() * h : h + 10 + Math.random() * 40,
        z,
        r: 0.8 + z * 2.2,
        v: 0.35 + z * 0.9,
        drift: (Math.random() - 0.5) * 0.6,
        phase: Math.random() * Math.PI * 2,
        life: 0.55 + Math.random() * 0.45,
      };
    };
    const resize = () => {
      w = host.clientWidth;
      h = host.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = Math.round(Math.min(70, (w * h) / 22000));
      sparks = Array.from({ length: count }, () => spawn(true));
    };
    const draw = () => {
      t += 1;
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      for (const s of sparks) {
        s.y -= s.v;
        s.x += s.drift + Math.sin(t / 40 + s.phase) * 0.35;
        const k = Math.max(0, Math.min(1, s.y / h)) * s.life;
        if (s.y < -20 || k <= 0.02) Object.assign(s, spawn(false));
        const flicker = 0.75 + Math.sin(t / 6 + s.phase) * 0.25;
        const a = (0.15 + s.z * 0.55) * k * flicker;
        const g = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, s.r * 4);
        g.addColorStop(0, `rgba(255,214,150,${a})`);
        g.addColorStop(0.35, `rgba(242,140,60,${a * 0.7})`);
        g.addColorStop(1, 'rgba(180,60,20,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r * 4, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
      raf = requestAnimationFrame(draw);
    };
    resize();
    window.addEventListener('resize', resize, { passive: true });
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !running) {
        running = true;
        draw();
      } else if (!entry.isIntersecting && running) {
        running = false;
        cancelAnimationFrame(raf);
      }
    }).observe(host);
  };
  if (!reduceMotion) document.querySelectorAll('[data-p-rain]').forEach(rain);

  /* Copier un code promo ------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    const code = btn.dataset.copyCode;
    const label = btn.querySelector('[data-copy-label]');
    const done = () => {
      if (!label) return;
      const prev = label.textContent;
      label.textContent = 'Code gekopieerd!';
      btn.classList.add('is-copied');
      setTimeout(() => {
        label.textContent = prev;
        btn.classList.remove('is-copied');
      }, 2200);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
    else done();
  });

  /* Mise en avant du code dans le panier : applique le code via l’URL /discount */
  document.querySelectorAll('[data-apply-code]').forEach((a) => {
    a.href = `/discount/${encodeURIComponent(a.dataset.applyCode)}?redirect=${encodeURIComponent(a.dataset.redirect || window.location.pathname)}`;
  });

  /* Vidéos en boucle : lecture quand elles sont visibles, pause sinon -------------- */
  const loopVideos = document.querySelectorAll('.a-reel__video, .a-vbanner__video');
  if (loopVideos.length && 'IntersectionObserver' in window) {
    const vio = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!(target instanceof HTMLVideoElement)) return;
        target.muted = true;
        if (isIntersecting && !reduceMotion) target.play().catch(() => {});
        else target.pause();
      });
    }, { threshold: 0.25 });
    loopVideos.forEach((v) => vio.observe(v));
  }

  /* Re-rendu du panier (tiroir ou page) sans rechargement ------------------------ */
  window.shopRefreshCart = async (inDrawer) => {
    try {
      if (inDrawer) {
        const res = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`).then((r) => r.json());
        const doc = new DOMParser().parseFromString(res['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('#CartDrawer');
        const current = document.querySelector('#CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res['cart-icon-bubble']) {
          const b = new DOMParser().parseFromString(res['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      } else {
        const sections = [...document.querySelectorAll('[id^="shopify-section-"]')]
          .filter((el) => el.querySelector('#main-cart-items, #main-cart-footer, cart-items, .cart__footer'))
          .map((el) => el.id.replace('shopify-section-', ''));
        const res = await fetch(`${window.location.pathname}?sections=${sections.join(',')}`).then((r) => r.json());
        sections.forEach((sid) => {
          const el = document.getElementById(`shopify-section-${sid}`);
          const html = res[sid];
          if (!el || !html) return;
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
        const bubble = document.getElementById('cart-icon-bubble');
        const r2 = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`).then((r) => r.json());
        const b = new DOMParser().parseFromString(r2['cart-icon-bubble'] || '', 'text/html').querySelector('.shopify-section');
        if (bubble && b) bubble.innerHTML = b.innerHTML;
      }
    } catch (e) {
      window.location.reload();
    }
  };

  /* Code promo dans le panier --------------------------------------------------- */
  /* Codes d’une autre boutique du même compte Shopify (bandeau RYTHM) : retirés du panier Braise,
     sinon ils restent mémorisés dans la session et s’appliquent au paiement. */
  const FOREIGN_CODES = [];
  class ACartCode extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.msg = this.querySelector('[data-msg]');
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        const code = this.input.value.trim();
        if (!code) {
          this.say('Vul je kortingscode in.', true);
          return;
        }
        if (FOREIGN_CODES.includes(code.toUpperCase())) {
          this.say('Deze code is niet geldig in deze winkel.', true);
          return;
        }
        this.apply(code);
      });
      this.querySelectorAll('[data-remove]').forEach((btn) =>
        btn.addEventListener('click', () => this.remove(btn.dataset.remove))
      );
    }
    say(text, error) {
      this.msg.textContent = text;
      this.msg.classList.toggle('is-error', !!error);
    }
    async current() {
      const cart = await fetch('/cart.js').then((r) => r.json());
      return (cart.discount_codes || []).map((d) => d.code);
    }
    async update(codes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') }),
      }).then((r) => r.json());
    }
    async apply(code) {
      const btn = this.querySelector('[type="submit"]');
      btn.disabled = true;
      this.say('Code controleren…');
      try {
        const existing = (await this.current()).filter((c) => c.toUpperCase() !== code.toUpperCase());
        const cart = await this.update([...existing, code]);
        const found = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
        if (found && found.applicable) {
          await this.refresh(`Code ${found.code} toegepast!`);
        } else {
          await this.update(existing);
          this.say('Deze code is niet geldig voor deze winkelwagen.', true);
        }
      } catch (err) {
        this.say('Er ging iets mis, probeer het opnieuw.', true);
      } finally {
        btn.disabled = false;
      }
    }
    async remove(code) {
      const codes = (await this.current()).filter((c) => c !== code);
      await this.update(codes);
      await this.refresh('Code verwijderd.');
    }
    /* Met à jour le panier (tiroir ou page) sans recharger la page */
    async refresh(message) {
      const id = this.dataset.id;
      await window.shopRefreshCart(!!this.closest('cart-drawer'));
      const next = document.querySelector(`a-cart-code[data-id="${id}"] [data-msg]`);
      if (next && message) next.textContent = message;
    }
  }
  if (!customElements.get('a-cart-code')) customElements.define('a-cart-code', ACartCode);

  (async () => {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const keep = codes.filter((c) => !FOREIGN_CODES.includes(c.toUpperCase()));
      if (keep.length === codes.length) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: keep.join(',') }),
      });
      if (window.shopRefreshCart && document.querySelector('cart-drawer, #main-cart-items')) {
        await window.shopRefreshCart(!document.querySelector('#main-cart-items'));
      }
    } catch (e) {
      /* panier indisponible : rien à faire */
    }
  })();

  /* Indicateur de défilement de la bannière */
  document.querySelectorAll('[data-hero-scroll]').forEach((a) =>
    a.addEventListener('click', (e) => {
      const next = a.closest('.shopify-section')?.nextElementSibling;
      if (!next) return;
      e.preventDefault();
      next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    })
  );

  /* Menus de l’en-tête : ouverture au survol (ordinateur) ------------------------ */
  const hoverMq = window.matchMedia('(hover: hover) and (min-width: 990px)');
  document.querySelectorAll('.header__inline-menu > ul > li').forEach((li) => {
    const details = li.querySelector(':scope > header-menu > details');
    if (!details) return;
    const summary = details.querySelector('summary');
    let timer;
    const setOpen = (open) => {
      if (details.open === open) return;
      details.open = open;
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    li.addEventListener('mouseenter', () => {
      if (!hoverMq.matches) return;
      clearTimeout(timer);
      document.querySelectorAll('.header__inline-menu details[open]').forEach((d) => {
        if (d !== details) {
          d.open = false;
          d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      });
      setOpen(true);
    });
    li.addEventListener('mouseleave', () => {
      if (!hoverMq.matches) return;
      timer = setTimeout(() => setOpen(false), 180);
    });
    // Au survol, le clic sur l’intitulé mène à la page (ex. la collection) au lieu de refermer le menu
    summary.addEventListener('click', (e) => {
      if (!hoverMq.matches) return;
      const href = li.dataset.href;
      if (href && details.open) {
        e.preventDefault();
        window.location.href = href;
      }
    });
  });

  /* Avis (cartes) : carrousel photo + grille texte ------------------------------ */
  document.querySelectorAll('.a-reviews').forEach((root) => {
    const track = root.querySelector('[data-rvp-track]');
    if (track) {
      const prev = root.querySelector('[data-rvp-prev]');
      const next = root.querySelector('[data-rvp-next]');
      const step = () => {
        const card = track.querySelector('.a-rvp__card');
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 4;
        prev.hidden = track.scrollLeft <= 4;
        next.hidden = track.scrollLeft >= max;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
      track.querySelectorAll('[data-rvp-media]').forEach((media) => {
        const imgs = [...media.querySelectorAll('.a-rvp__img')];
        const btn = media.querySelector('[data-rvp-next-img]');
        if (!btn || imgs.length < 2) return;
        let i = 0;
        const label = btn.querySelector('[data-rvp-count]');
        const show = () => {
          imgs.forEach((im, k) => im.classList.toggle('is-active', k === i));
          label.textContent = `${i + 1}/${imgs.length}`;
        };
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          i = (i + 1) % imgs.length;
          show();
        });
        media.dataset.current = '0';
        btn.addEventListener('click', () => (media.dataset.current = String(i)));
        show();
      });
    }
    const grid = root.querySelector('[data-rvt]');
    if (grid) {
      const per = parseInt(grid.dataset.perPage, 10) || 6;
      const cards = [...grid.children];
      const wrap = root.querySelector('[data-rvt-more-wrap]');
      let shown = per;
      const render = () => {
        cards.forEach((c, k) => (c.hidden = k >= shown));
        wrap.hidden = shown >= cards.length;
      };
      root.querySelector('[data-rvt-more]')?.addEventListener('click', () => {
        shown += per;
        render();
      });
      render();
    }
  });

  /* Avis : visionneuse photo ------------------------------------------------------ */
  document.querySelectorAll('.a-reviews').forEach((root) => {
    const dlg = root.querySelector('[data-lightbox]');
    if (!dlg) return;
    const img = dlg.querySelector('[data-lb-img]');
    const count = dlg.querySelector('[data-lb-count]');
    const text = dlg.querySelector('[data-lb-text]');
    const author = dlg.querySelector('[data-lb-author]');
    const prev = dlg.querySelector('[data-lb-prev]');
    const next = dlg.querySelector('[data-lb-next]');
    let urls = [];
    let idx = 0;
    const show = () => {
      img.src = urls[idx];
      const many = urls.length > 1;
      prev.hidden = next.hidden = !many;
      count.textContent = many ? `${idx + 1} / ${urls.length}` : '';
    };
    const open = (media) => {
      urls = (media.dataset.full || '').split('|').filter(Boolean).map((u) => (u.startsWith('//') ? 'https:' + u : u));
      if (!urls.length) return;
      idx = parseInt(media.dataset.current || '0', 10) || 0;
      text.textContent = media.dataset.text || '';
      author.textContent = media.dataset.author || '';
      show();
      dlg.showModal();
      document.body.classList.add('p-dialog-open');
    };
    root.querySelectorAll('[data-rvp-media]').forEach((media) => {
      media.addEventListener('click', () => open(media));
      media.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(media);
        }
      });
    });
    prev.addEventListener('click', () => {
      idx = (idx - 1 + urls.length) % urls.length;
      show();
    });
    next.addEventListener('click', () => {
      idx = (idx + 1) % urls.length;
      show();
    });
    dlg.querySelector('[data-lb-close]').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('keydown', (e) => {
      if (urls.length < 2) return;
      if (e.key === 'ArrowRight') next.click();
      if (e.key === 'ArrowLeft') prev.click();
    });
    dlg.addEventListener('close', () => document.body.classList.remove('p-dialog-open'));
  });
})();

/* Bulle « Ajouter » (accessoire) : ajout direct au panier, sans quitter la fiche */
if (!customElements.get('a-upsell')) {
  customElements.define('a-upsell', class AUpsell extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-upsell-variant]').forEach((b) => b.addEventListener('click', () => {
        this.dataset.variantId = b.dataset.upsellVariant;
        this.querySelectorAll('[data-upsell-variant]').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b); });
        const img = this.querySelector('.a-upsell__media img');
        if (img && b.dataset.img) { img.src = b.dataset.img; img.removeAttribute('srcset'); }
        this.classList.remove('is-added');
      }));
      this.querySelector('[data-upsell-select]')?.addEventListener('change', (e) => {
        const o = e.target.selectedOptions[0];
        this.dataset.variantId = o.value;
        const img = this.querySelector('.a-upsell__media img');
        if (img && o.dataset.img) { img.src = o.dataset.img; img.removeAttribute('srcset'); }
        this.classList.remove('is-added');
      });
      this.querySelector('[data-upsell-add]')?.addEventListener('click', () => this.add());
    }
    async add() {
      if (this.classList.contains('is-loading')) return;
      if (!this.dataset.variantId) { const sel = this.querySelector('[data-upsell-select], [data-upsell-sizes]'); if (sel) { sel.classList.add('is-required'); sel.focus(); setTimeout(() => sel.classList.remove('is-required'), 1600); } return; }
      this.classList.add('is-loading');
      const drawer = document.querySelector('cart-drawer');
      try {
        const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(this.dataset.variantId), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
        }).then((r) => r.json());
        if (res.status) throw new Error(res.description || res.message);
        this.classList.add('is-added');
        if (this.classList.contains('a-upsell--cart')) {
          await window.shopRefreshCart(!!this.closest('cart-drawer'));
        } else if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.classList.remove('is-loading');
      }
    }
  });
}

